import {
  parseISO,
  formatDistanceToNow,
  differenceInCalendarDays,
} from 'date-fns';

export const convertDateToRelativeDay = (dateString: string): string => {
  const parsedDate = parseISO(dateString);
  const now = new Date();

  const dayDifference = Math.abs(differenceInCalendarDays(parsedDate, now));

  if (dayDifference === 0) {
    return 'Today';
  } else if (dayDifference === 1) {
    return 'Yesterday';
  } else if (dayDifference > 1) {
    return `${dayDifference} days ago`;
  } else {
    return formatDistanceToNow(parsedDate, { addSuffix: true });
  }
};

export const formatElapsedTime = (timestamp: Date | number): string => {
  return formatDistanceToNow(timestamp, {
    addSuffix: true,
    includeSeconds: true,
  });
};

export const formatIn12Hrs = (timestamp: string | Date): string => {
  const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};
